module.exports = __webpack_public_path__ + "img/crile3.0aaff860.png";